<script>
    import ConclusionModal from "./ConclusionModal";

    export default {
        components: {
            ConclusionModal
        },

        props: {
            costCenters: {
                type: Array,
                required: true,
            },
            costCarriers: {
                type: Array,
                required: true,
            },
        },

        methods: {
            showConclusionModal(travelExpenseReport) {
                this.$modal.show(ConclusionModal, {
                    travelExpenseReport: travelExpenseReport,
                    costCenters: this.costCenters,
                    costCarriers: this.costCarriers,
                }, {height: 'auto', width: '66%'});
            }
        },

        mounted() {
            $(document).on('click', '.approve-report', function () {
                let clicked = $(this);
                let reportId = clicked.data('report-id');

                clicked.prop('disabled', true);
                clicked.find('span').hide();
                clicked.find('i.fa-spinner').show();
                clicked.find('i.fa-check').hide();

                axios
                    .post(`/travel-expense-report/${reportId}/approve`)
                    .then(response => {
                        clicked.parents('.report-row').removeClass('tw-bg-warning-secondary').addClass('tw-bg-success-secondary');
                        clicked.parents('.report-row').find('.delete-report, .edit-report').remove();
                        clicked.parents('.report-row').find('.show-conclusion').replaceWith('<span>' + response.data.billed_at + '</span>');
                        clicked.remove();
                    })
                    .catch(error => {
                        alert('Es trat ein unerwarteter Fehler auf!');
                    });
            });
        }
    }
</script>
